"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MULTIPLE_CHOICE = exports.CALENDLY_FORM = exports.FORM_FIELDS_WRAPPER = exports.FORM_WRAPPER = exports.VIDEO = exports.TEXT_REDRAFT = exports.TEXT = exports.PLYR_WRAPPER = exports.PAGE = exports.INPUT = exports.ILLUSTRATION = exports.IMAGEIX = exports.IMAGE = exports.ICON = exports.CLOSE_BUTTON = exports.CAROUSEL_DOT = exports.CAROUSEL_ARROW = exports.BOX = void 0;
var BOX = 'CAtomBox';
exports.BOX = BOX;
var CAROUSEL_ARROW = 'CAtomCarouselArrow';
exports.CAROUSEL_ARROW = CAROUSEL_ARROW;
var CAROUSEL_DOT = 'CAtomCarouselDot';
exports.CAROUSEL_DOT = CAROUSEL_DOT;
var CLOSE_BUTTON = 'CAtomCloseButton';
exports.CLOSE_BUTTON = CLOSE_BUTTON;
var ICON = 'CAtomIcon';
exports.ICON = ICON;
var IMAGE = 'CAtomImage';
exports.IMAGE = IMAGE;
var IMAGEIX = 'CAtomImageix';
exports.IMAGEIX = IMAGEIX;
var ILLUSTRATION = 'CAtomIllustration';
exports.ILLUSTRATION = ILLUSTRATION;
var INPUT = 'CAtomInput';
exports.INPUT = INPUT;
var PAGE = 'CAtomPage';
exports.PAGE = PAGE;
var PLYR_WRAPPER = 'CAtomPlyrWrapper';
exports.PLYR_WRAPPER = PLYR_WRAPPER;
var TEXT = 'CAtomText';
exports.TEXT = TEXT;
var TEXT_REDRAFT = 'CAtomTextRedraft';
exports.TEXT_REDRAFT = TEXT_REDRAFT;
var VIDEO = 'CAtomVideo';
exports.VIDEO = VIDEO;
var FORM_WRAPPER = 'CAtomFormWrapper';
exports.FORM_WRAPPER = FORM_WRAPPER;
var FORM_FIELDS_WRAPPER = 'CAtomFormFieldsWrapper';
exports.FORM_FIELDS_WRAPPER = FORM_FIELDS_WRAPPER;
var CALENDLY_FORM = 'CAtomCalendlyForm';
exports.CALENDLY_FORM = CALENDLY_FORM;
var MULTIPLE_CHOICE = 'CAtomMultipleChoice';
exports.MULTIPLE_CHOICE = MULTIPLE_CHOICE;